import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useSubmissionsContext } from '../../../context/submissions';
import FilterButton from './FilterButton';
import FilterOptions from './FilterOptions';

const MaterialLogFilters = () => {
  const { filters } = useSubmissionsContext();
  const [isFieldDropdownOpen, setIsFieldDropdownOpen] = useState(false);
  const [isValueDropdownOpen, setIsValueDropdownOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(null);

  const closeAllDropdowns = () => {
    setIsFieldDropdownOpen(false);
    setIsValueDropdownOpen(false);
    setSelectedField(null);
  };

  const toggleFieldDropdown = () => {
    const isAnyDropdownOpen = isFieldDropdownOpen || isValueDropdownOpen;
    isAnyDropdownOpen ? closeAllDropdowns() : setIsFieldDropdownOpen(true);
  };

  const handleFieldSelect = (field) => {
    setSelectedField(field);
    setIsValueDropdownOpen(true);
  };

  const handleKeyPress = (e) => {
    if (e.key.toLowerCase() === 'f') {
      setTimeout(() => setIsFieldDropdownOpen(true), 10);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <Grid>
      <ClickAwayListener onClickAway={closeAllDropdowns}>
        <div className="relative inline-block">
          <FilterButton filters={filters} toggleFieldDropdown={toggleFieldDropdown} />
          <FilterOptions
            isFieldDropdownOpen={isFieldDropdownOpen}
            isValueDropdownOpen={isValueDropdownOpen}
            selectedField={selectedField}
            handleFieldSelect={handleFieldSelect}
            closeAllDropdowns={closeAllDropdowns}
          />
        </div>
      </ClickAwayListener>
    </Grid>
  );
};

export default MaterialLogFilters;
